import { evaluateDocument } from '../evaluate-document';
export function createElementMatchOperator(allOperators) {
    return (fieldValue, conditionValue, _document) => {
        if (!Array.isArray(fieldValue))
            return false;
        return fieldValue.some((element) => {
            return evaluateDocument(element, conditionValue, allOperators);
        });
    };
}
